/** Address shortener: 0x57829c5f…1860c9 */
export const short = (a?: string | null): string =>
  a ? `${a.slice(0, 6)}…${a.slice(-4)}` : '—';

/** Lossy bigint-to-number for display only — never use for math. */
const toNumber = (v: bigint | number | string): number =>
  typeof v === 'bigint' ? Number(v) : Number(v);

export const fmt = {
  eth: (v: bigint | number | string) => toNumber(v).toFixed(4),

  meth: (v: bigint | number | string) =>
    toNumber(v).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),

  pct: (v: number) => `${v.toFixed(1)}%`,

  ttlShort: (sec: number) => {
    const s = Math.max(0, Math.floor(sec));
    if (s < 60)    return `${s}s`;
    if (s < 3600)  return `${Math.floor(s / 60)}m ${s % 60}s`;
    if (s < 86400) {
      const h = Math.floor(s / 3600);
      const m = Math.floor((s % 3600) / 60);
      return `${h}h ${String(m).padStart(2, '0')}m`;
    }
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    return `${String(d).padStart(2, '0')}d ${String(h).padStart(2, '0')}h`;
  },

  ttl: (sec: number) => {
    const s = Math.max(0, Math.floor(sec));
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    const m = Math.floor((s % 3600) / 60);
    return `${String(d).padStart(2, '0')}d ${String(h).padStart(2, '0')}h ${String(m).padStart(2, '0')}m`;
  },

  blockNumber: (n: number | bigint) =>
    Number(n).toLocaleString('en-US'),
};

export const weiToEth = (wei: bigint | number | string): number =>
  Number(wei) / 1e18;

export const ethToWei = (eth: number | string): bigint =>
  BigInt(Math.round(Number(eth) * 1e18));
